import { useEffect } from "react";
import useVaultIdParam from "@app/Areas/Optimus/State/App/NavigationContext/hooks/useVaultIdParam";
import { useTaskBoardStateContext, useTaskBoardDispatchContext } from "@app/Areas/Optimus/Apps/TaskBoardApp";
import { BOARDS_CLEAR_TASKLIST_UNDER_DELETE } from "../../../state/TaskBoardReducer/TaskBoardReducer";
import useBoardIdParam from "../../_Boards/useBoardIdParam";

function useTaskListUnderDelete() {
    const vaultId = useVaultIdParam();
    const boardId = useBoardIdParam();

    const boardStateContext = useTaskBoardStateContext();
    const taskListUnderDelete = boardStateContext.taskLists.selectedToDelete;
    const boardDispatch = useTaskBoardDispatchContext();

    useEffect(() => {
        return function cleanup() {
            boardDispatch({
                type: BOARDS_CLEAR_TASKLIST_UNDER_DELETE
            })
        }
    }, [vaultId])

    if (!taskListUnderDelete) {
        return null;
    }

     const taskList = boardStateContext?.taskLists?.byId[taskListUnderDelete];

    if (
        !taskList
        || taskList.parentVaultId !== vaultId
        || taskList.parentBoardId !== boardId) {
        return null;
    }

    return taskList;
}

export default useTaskListUnderDelete;
